/**
 * Staff Hub (WP4-HR). Two places:
 *
 * - My Hub (`/me`): every employee's own page, first in the avatar menu with
 *   a badge for overdue items. Today, Time & pay (read from the timeclock;
 *   pay stubs stay in Square), Licenses & CE, Documents (handbook sign-off)
 *   and Profile.
 * - Team & HR (`/settings/team`, Settings > People): the managers' people
 *   list, the compliance grid with CSV export and print, handbook and policy
 *   publishing with the sign-off roster, and the alert log.
 *
 * In the Dentrix skin both open from Office Manager: Maintenance > Practice
 * Setup > Staff / Employees and Reports > Employee Compliance. API: `/v1/hr`.
 */
import { defineManifest } from '@velora/contracts';
import { defineWebModule } from '../../app/module.js';

export default defineWebModule({
  manifest: defineManifest({
    id: 'hr',
    title: 'Staff Hub',
    version: '0.1.0',
    owner: 'WP4-HR',
    entitlementKey: null,
    permissions: ['hr.self', 'hr.view', 'hr.manage', 'hr.view_sensitive'],
    routes: [
      {
        id: 'my-hub',
        path: '/me',
        title: 'My Hub',
        officeScope: 'practice',
        permission: 'hr.self',
      },
      {
        id: 'team',
        path: '/settings/team',
        title: 'Team & HR',
        officeScope: 'location-or-all',
        permission: 'hr.view',
      },
    ],
    nav: [
      {
        label: 'Team & HR',
        group: 'settings',
        routeId: 'team',
        icon: 'users-round',
        order: 915,
        permission: 'hr.view',
      },
    ],
    commands: [
      {
        id: 'hr.my-hub',
        title: 'My Hub',
        keywords: ['me', 'my license', 'hours', 'timesheet', 'handbook', 'pay stub', 'profile'],
        routeId: 'my-hub',
        permission: 'hr.self',
      },
      {
        id: 'hr.team',
        title: 'Team & HR',
        keywords: ['staff', 'employees', 'hr', 'licenses', 'credentials', 'handbook'],
        routeId: 'team',
        permission: 'hr.view',
      },
    ],
  }),
  pages: {
    'my-hub': () => import('./pages/MyHubPage.js'),
    team: () => import('./pages/TeamPage.js'),
  },
});
